import { render, staticRenderFns } from "./MenuPicture.vue?vue&type=template&id=ce7d6a6a&scoped=true&"
import script from "./MenuPicture.vue?vue&type=script&lang=js&"
export * from "./MenuPicture.vue?vue&type=script&lang=js&"
import style0 from "./MenuPicture.vue?vue&type=style&index=0&id=ce7d6a6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7d6a6a",
  null
  
)

export default component.exports